/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MediaSectionContainerLocal = {
    readonly expandedMediaSettings: {
        readonly commentIDs: ReadonlyArray<string>;
    } | null;
    readonly " $refType": "MediaSectionContainerLocal";
};
export type MediaSectionContainerLocal$data = MediaSectionContainerLocal;
export type MediaSectionContainerLocal$key = {
    readonly " $data"?: MediaSectionContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"MediaSectionContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MediaSectionContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExpandedMediaSettings",
                    "kind": "LinkedField",
                    "name": "expandedMediaSettings",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "commentIDs",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '0b872a818b05e2359d52609755306178';
export default node;
